import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function LuxembourgLeadersPage() {
  const leaders = [
    {
      name: 'Sofiya Kudryavtseva',
      title: 'Writer, Film Director & Acting Coach',
      location: 'Luxembourg 🇱🇺',
      image: 'https://public.readdy.ai/ai/img_res/e54334d5a5df1b8c57d83269730674b9.jpg',
      bio: 'Sofiya Kudryavtseva is a writer and film director with an MA in Philosophy, based in Luxembourg. She organizes acting and film workshops through her educational project ActingLU, empowering aspiring actors and filmmakers to find their voice and tell their stories.',
      work: [
        'Film directing and screenwriting',
        'Acting workshops and coaching',
        'Philosophy and creative arts education',
        'Empowering storytellers through film'
      ],
      contact: {
        instagram: '@actinglu',
        website: 'actinglu.com',
        type: 'Acting & Film Workshops'
      }
    },
    {
      name: 'Bahar Yetis Irez',
      title: 'Professional Numerologist',
      location: 'Luxembourg 🇱🇺',
      image: 'https://readdy.ai/api/search-image?query=professional%20numerologist%20woman%20with%20spiritual%20mystical%20aesthetic%20surrounded%20by%20numbers%20sacred%20geometry%20crystals%20tarot%20cards%20soft%20ethereal%20lighting%20peaceful%20wise%20atmosphere%20spiritual%20teacher%20guide%20portrait&width=600&height=800&seq=bahar-leader-001&orientation=portrait',
      bio: 'Bahar Yetis Irez is a professional numerologist who shares her deep knowledge of numerology and spiritual guidance on social media. She helps people understand their life paths, purpose, and personal growth through the ancient wisdom of numbers.',
      work: [
        'Numerology readings and consultations',
        'Life path and destiny number analysis',
        'Spiritual guidance and personal growth',
        'Educational content on numerology'
      ],
      contact: {
        instagram: '@numerolojinin.yolu',
        type: 'Numerology & Spiritual Guidance'
      }
    },
    {
      name: 'Judit Nagy',
      title: 'Voice Communication & Personal Growth Coach',
      location: 'Luxembourg 🇱🇺',
      image: 'https://readdy.ai/api/search-image?query=professional%20hungarian%20woman%20coach%20confident%20speaker%20voice%20communication%20trainer%20personal%20growth%20mentor%20warm%20encouraging%20expression%20natural%20lighting%20professional%20portrait%20coaching%20session%20atmosphere&width=600&height=800&seq=judit-leader-001&orientation=portrait',
      bio: 'Judit Nagy is a Hungarian voice communication and personal growth coach based in Luxembourg. She helps individuals discover the power of their voice, improve communication skills, and unlock their personal potential through transformative coaching programs.',
      work: [
        'Voice communication training',
        'Personal growth coaching',
        'Year-launching coaching events',
        'Workshops and group coaching sessions'
      ],
      contact: {
        website: 'juditnagy.info',
        registration: 'my.weezevent.com/year-launching-cocho-coaching-event',
        type: 'Coaching & Workshops'
      }
    },
    {
      name: 'Silvia Gimenez',
      title: 'Solo Travel Organizer & Empowerment Leader',
      location: 'International',
      image: 'https://readdy.ai/api/search-image?query=adventurous%20woman%20travel%20organizer%20standing%20confidently%20in%20beautiful%20destination%20inspiring%20leader%20for%20solo%20female%20travelers%20warm%20welcoming%20smile%20professional%20portrait%20empowering%20atmosphere%20travel%20guide%20educator&width=600&height=800&seq=silvia-leader-001&orientation=portrait',
      bio: 'Silvia Gimenez is the founder of Maganda Experience, organizing empowering solo travel experiences for women. Yaren Cevik made her first solo travel with Silvia\'s organization, discovering the transformative power of solo adventure and female solidarity.',
      work: [
        'Organizing solo travel experiences for women',
        'Creating safe travel communities',
        'Empowering women through adventure',
        'Solo travel coaching and guidance'
      ],
      contact: {
        instagram: '@silviagimenezz',
        organization: 'Maganda Experience',
        type: 'Solo Travel Organizer'
      }
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-purple-50 via-pink-50 to-rose-50">
        <div className="max-w-4xl mx-auto text-center">
          <Link 
            to="/blog"
            className="inline-flex items-center gap-2 text-purple-600 hover:text-purple-700 mb-6 font-medium cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Back to Blog
          </Link>

          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Inspiring Women Leaders
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
              Luxembourg, Spain, Turkey
            </span>
          </h1>

          <p className="text-xl text-gray-600 mb-8">
            Meet the remarkable women making a difference through film, spirituality, coaching, and travel empowerment.
          </p>
        </div>
      </section>

      {/* Leaders Grid */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid gap-16">
            {leaders.map((leader, index) => (
              <div 
                key={index}
                className={`grid md:grid-cols-2 gap-8 items-center ${
                  index % 2 === 1 ? 'md:flex-row-reverse' : ''
                }`}
              >
                <div className={`${index % 2 === 1 ? 'md:order-2' : ''}`}>
                  {/* Image container removed */}
                </div>

                <div className={`${index % 2 === 1 ? 'md:order-1' : ''}`}>
                  <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
                    <i className="ri-map-pin-line"></i>
                    <span>{leader.location}</span>
                  </div>

                  <h2 className="text-4xl font-bold text-gray-900 mb-2">
                    {leader.name}
                  </h2>

                  <p className="text-xl text-purple-600 font-semibold mb-6">
                    {leader.title}
                  </p>

                  <p className="text-lg text-gray-700 leading-relaxed mb-8">
                    {leader.bio}
                  </p>

                  <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6 mb-8">
                    <h3 className="font-bold text-gray-900 text-lg mb-4">
                      Her Work:
                    </h3>
                    <ul className="space-y-3">
                      {leader.work.map((item, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <i className="ri-star-fill text-purple-600 text-lg flex-shrink-0 mt-1"></i>
                          <span className="text-gray-700">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="flex flex-wrap gap-4">
                    {leader.contact.instagram && (
                      <a
                        href={`https://instagram.com/${leader.contact.instagram.replace('@', '')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-6 py-3 rounded-xl font-semibold hover:opacity-90 transition-all cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-instagram-line text-xl"></i>
                        <span>{leader.contact.instagram}</span>
                      </a>
                    )}
                    {leader.contact.website && (
                      <a
                        href={`https://${leader.contact.website}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 bg-purple-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-purple-700 transition-all cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-global-line text-xl"></i>
                        <span>Website</span>
                      </a>
                    )}
                    {leader.contact.registration && (
                      <a
                        href={`https://${leader.contact.registration}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 bg-pink-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-pink-700 transition-all cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-calendar-check-line text-xl"></i>
                        <span>Register for Workshop</span>
                      </a>
                    )}
                  </div>

                  <div className="mt-4 inline-flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-briefcase-line"></i>
                    <span>{leader.contact.type}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-r from-purple-600 to-pink-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <i className="ri-user-star-line text-6xl mb-6 block"></i>
          <h2 className="text-4xl font-bold mb-4">
            Know an Inspiring Woman Leader?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Help us celebrate more women making a difference in their communities. 
            Share their stories with us.
          </p>
          <a
            href="mailto:contact@shecan.org"
            className="inline-flex items-center gap-2 bg-white text-purple-600 px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-line text-xl"></i>
            <span>Nominate a Leader</span>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
